import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import {
  AppHttpError,
  mapStatusToHttpErrorType,
} from '../http/app-http-error';

/**
 * Global HTTP interceptor that converts {@link HttpErrorResponse} instances
 * into {@link AppHttpError} so components can branch on {@link HttpErrorType}
 * instead of raw status codes.
 *
 * @see AppHttpError
 * @see mapStatusToHttpErrorType
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        return throwError(
          () =>
            new AppHttpError(mapStatusToHttpErrorType(err.status), err.status),
        );
      }
      return throwError(() => err);
    }),
  );
